<template>
  <div class="content">
    <div class="content-text">
      <h3 class="content-title">辅助设计</h3>
    </div>
    <el-button class="content-operate" size="small"
                v-for="btn in assistBtns"
                :key="btn.id"
                @click="openDownloadList(btn.id)">{{ btn.value }}
    </el-button>
  </div>
</template>

<script>
import {Message} from 'element-ui'
import {WinForm} from '@/libs'

export default {
  data() {
    return {
      assistBtns: [
        {id: 1, value: "安装SOLIDWORKS插件"},
        {id: 2, value: "安装材质库"},
        {id: 3, value: "安装文件模板"},
        {id: 4, value: "安装焊接轮廓库"},
      ],
    }
  },
  methods: {
    openDownloadList(id) {
      /*
      *   {id: 1, value: "安装SOLIDWOEKS插件"},
          {id: 2, value: "安装迈迪材质库"},
          {id: 3, value: "安装迈迪文件模板"},
          {id: 4, value: "安装焊接轮廓库"},*/
      let res;
      switch (id) {
        case 1:
          WinForm.tools.registerSwTool();
          break;
        case 2:
          res = WinForm.tools.installMdMaterialLib();
          break;
        case 3:
          res = WinForm.tools.installMdFileTemplate();
          break
        case 4:
          res = WinForm.tools.installHJLKLib();
          break;
      }
      if (res === "success") {
        Message.success("安装成功！")
      } else {
        res && Message.warning(WinForm.tools.checkSWOpen() ? '请先安装SolidWorks插件' : "SolidWorks未运行,请打开后重试！")
      }
      ;
    },
  },
}
</script>

